<template>
  <div>
    <Common :rules="rules" ref="common">
      <template v-slot:context>
        <my-search
          timeScreen
          :inputArr="inputArr"
          :order="1"
          :searchParams="searchParams"
          @searchEvent="searchEvent"
        />
        <el-card class="show" shadow="never">
          <div class="showCurrent">
            <div class="show" v-show="name">
              当前文章：<span>{{ name }}</span>
            </div>
          </div>

          <el-form-item prop="docId">
            <!-- 表格展示查询的数据  -->
            <my-table
              ref="showArticle"
              flag="showArticle"
              :loading="loading"
              :tableData="tableData"
              :tableHeader="tableHeader"
              @handleCurrentChange="handleCurrentChange"
              @handleRowdbClick="handleRowdbClick"
            />
          </el-form-item>
          <!-- 分页器 -->
          <my-pagination
            :childMsg="pageParams"
            @callFather="callFather"
          />
        </el-card>
      </template>
    </Common>
  </div>
</template>

<script>
import { articeList } from "@/network/content/artice";
import Common from "./common.vue";
import { canSearch } from "../../utils/utils";
// 清除高亮
function clearActive(obj) {
  obj.$refs.common.ruleForm.docId = "";
  obj.$refs.showArticle.handleRowdbClick();
  obj.name = "";
}
import mixins from "@/mixins/common";
export default {
  name: "push_article",
  mixins: [mixins],
  components: {
    Common,
  },
  data() {
    return {
      name: "",
      // 搜索参数
      searchParams: { docTitle: "", timeOptions: [] },
      inputArr: [
        {
          name: "docTitle",
          defaultText: "请输入文章名称",
        },
      ],
      tableHeader: Object.freeze([
        {
          name: "文档名称",
          prop: "docTitle",
          width: "300px",
        },
        {
          name: "文档简介",
          prop: "docIntroduction",
        },
        {
          name: "发布时间",
          prop: "startTime",
        },
      ]),
      //验证文章选中id
      rules: {
        docId: [
          {
            required: true,
            message: "请选择推送文章",
          },
        ],
      },
    };
  },
  methods: {
    async getInitData(isSearch) {
      // 清除高亮
      clearActive(this);
      // 收集参数
      let timeOptions = this.searchParams.timeOptions;
      let params = {
        docTitle: this.searchParams.docTitle,
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      let { data } = await articeList(params);
      if (data.code == 200) {
        this.loading = false;
        if (!data.data.records.length) {
          this.$message("没有搜索到相关数据");
        }
        this.tableData = data.data.records;
        this.pageParams.total = data.data.total;
        if (isSearch) this.pageParams.currentPage = 1;
      }
    },
    // 搜索数据
    searchEvent() {
      // 相同关键在避免二次搜索  ture表示没有数据发生改变
      if (canSearch(this, this.searchParams)) return;
      console.log("搜索了");
      // }
      this.getInitData(true);
    },
    // 文章表格手机文章id
    handleCurrentChange(val) {
      this.$refs.common.ruleForm.docId = val.id;
      this.name = val.docTitle;
    },
    // 双击取消选中当前文章
    handleRowdbClick(row) {
      // 双击会触发单机事件
      this.$refs.common.ruleForm.docId = "";
      if (row.docTitle == this.name) {
        this.name = "";
      }
    },
  },
};
</script>

<style scoped>
.show /deep/ .el-form-item__content {
  margin-left: 0px !important;
}
.showCurrent {
  height: 40px;
}
.show {
  color: #606266;
  position: relative;
  bottom: -15px;
  left: 0;
  font-size: 14px;
  margin-bottom: 50px;
}
.show span {
  font-size: 13px;
}
</style>
